module.exports = __webpack_public_path__ + "static/media/timer-right.33443db3.svg";